<template>
   <div class="container-fluid  login">
    <div class="position-relative w-100 h-100">
      <div class="card card-login ">
        <div class="login-header ">
          <div class="row login-header-content">
            <img
              class="col-4"
              :src="require('@/assets/icons/oomur_logo_white.svg')"
              alt="user icon"
            />
            <div class="col-8 text-left pt-1 pr-2">
               <p>Observatorio Oceanográﬁco Móvil Región de Murcia</p>
            </div>
          </div>
        </div>
        <div class="card-body login-body">
          <login v-if="viewComponent == 'login'"></login> 
          <forgottenPass  v-else-if = "viewComponent == 'forgot'"></forgottenPass>
          <resetPass  v-else-if = "viewComponent == 'reset'" v-bind:token = $route.query.token  ></resetPass>
        </div>
      </div>
      <!-- card.// -->
    </div>
  </div>
</template>

<script>
import login from '@/components/autenticacion/login.vue'
import forgottenPass from '@/components/autenticacion/forgotten_pass.vue'
import resetPass from '@/components/autenticacion/reset_pass.vue'
  export default {
    components: {
      login,
      forgottenPass,
      resetPass
    },
     data(){
      return {
        viewComponent: 'login',
        token: ''
      }
    },
    mounted(){
      if(this.$route.query.token) 
        this.viewComponent = 'reset' 
    },
    methods: {

    },
    beforeMount(){
      this.$store.dispatch('refresh_token')
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/autenticacion/layout.vue